import { render, staticRenderFns } from "./TutorDashboardShiftSummaryNoShift.vue?vue&type=template&id=2ea63d98&scoped=true&"
import script from "./TutorDashboardShiftSummaryNoShift.vue?vue&type=script&lang=js&"
export * from "./TutorDashboardShiftSummaryNoShift.vue?vue&type=script&lang=js&"
import style0 from "./TutorDashboardShiftSummaryNoShift.vue?vue&type=style&index=0&id=2ea63d98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea63d98",
  null
  
)

export default component.exports